// extracted by mini-css-extract-plugin
export default {"actions":"styles_actions_bidSv","wrap":"styles_wrap_zl6TT","allowShrink":"styles_allow-shrink_NtMyt"};